import React from 'react'
import { studies } from '../constant/data'

const ClinicalStudies = () => {

    

    return (
        <div className="bg-[#E6E4E0] px-4">
            <div className="max-w-7xl mx-auto py-8">
                <h2 className="text-[#737270] text-lg font-bold mb-6 text-center">
                    Supporting Clinical Studies:
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-2 pb-10">
                    {studies.map((study) => (
                        <a
                            key={study.id}
                            href={study.url}
                            className="text-gray-900 font-medium underline text-xs italic break-all"
                        >
                            {study.id}. {study.url}
                        </a>
                    ))}
                </div>

                <div className="pt-8 border-t border-black text-xs text-gray-600 space-y-4 text-center ">
                    <p>
                    *This site is not a part of the Facebook website or Facebook Inc. Additionally, This site is NOT endorsed by Facebook in any way. FACEBOOK is a trademark of FACEBOOK, Inc. These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease.. The information provided on this site is for informational purposes only and is not intended as a substitute for advice from your physician or other health care professional or any information contained on or in any product label or packaging. You should not use the information on this site for diagnosis or treatment of any health problem or for prescription of any medication or other treatment. You should consult with a healthcare professional before starting any diet, exercise or supplementation program, before taking any medication, or if you have or suspect you might have a health problem.
                    </p>
                    <p>
                    Medical Disclaimer: The content is not intended to be a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or another qualified health provider with any questions you may have regarding a medical condition. Seek your doctor's advice before changing or discontinuing any prescription. The information provided on this page is not intended to replace a prescription or any medical treatment. Never disregard professional medical advice or delay in seeking it because of something you have read on this website.
                    </p>
                    <p className="text-center">
                        ©Sinoclear.net 2025. All Rights Reserved
                    </p>
                </div>

                <footer className="mt-6 text-center text-sm  text-gray-700">
                    <nav className="space-x-2">
                        <a href="#" className="hover:underline">Privacy Policy</a>
                        <span>|</span>
                        <a href="#" className="hover:underline">Terms</a>
                        <span>|</span>
                        <a href="#" className="hover:underline">Contact</a>
                        <span>|</span>
                        <a href="#" className="hover:underline">Returns</a>
                        <span>|</span>
                        <a href="#" className="hover:underline">Disclaimer</a>
                    </nav>
                </footer>
            </div>
        </div>
    )
}

export default ClinicalStudies

